import script from "./next-event-copy.vue?vue&type=script&setup=true&lang=js"
export * from "./next-event-copy.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__